import '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import { mapTruncateValue } from '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';

var mapElementToSize = function mapElementToSize(element) {
  switch (element) {
    case 'h6':
      return 'xs';

    case 'h5':
      return 'sm';

    case 'h4':
      return 'md';

    case 'h3':
      return 'lg';

    case 'h2':
      return 'xl';

    case 'h1':
      return '2xl';

    default:
      return 'base';
  }
};

function useHeadingStyles(options) {
  var as = options.as,
      _options$size = options.size,
      size = _options$size === void 0 ? mapElementToSize(as) : _options$size,
      _options$truncate = options.truncate,
      truncate = _options$truncate === void 0 ? false : _options$truncate;
  var props = {
    truncate: mapTruncateValue(truncate),
    textColor: size === 'xs' ? 'text-gray-400' : 'text-gray-800'
  };

  if (size !== 'xs') {
    props.fontWeight = 'font-semibold';
    props.letterSpacing = 'tracking-tight';
  }

  switch (size) {
    case '2xl':
      props.fontSize = ['text-4xl', 'lg:text-5xl'];
      break;

    case 'xl':
      props.fontSize = ['text-3xl', 'lg:text-4xl'];
      break;

    case 'lg':
      props.fontSize = ['text-2xl', 'lg:text-3xl'];
      break;

    case 'md':
      props.fontSize = ['text-lg', 'lg:text-2xl'];
      break;

    case 'sm':
      props.fontSize = ['text-base', 'lg:text-lg'];
      break;

    case 'base':
      props.fontSize = 'text-base';
      break;

    case 'xs':
      props.fontSize = 'text-xs';
      props.fontWeight = 'font-medium';
      props.textTransform = 'uppercase';
      props.letterSpacing = 'tracking-wide';
      break;
  }

  return props;
}

export default useHeadingStyles;
//# sourceMappingURL=styles.esm.js.map
